import { TentativeBookingDTO, TravellerDTO } from "../../apiclient/ApiDtos";
import { SeatReservationFsmContext } from "../seatreservation/SeatReservationFsmContext";
import { WayPointSelectionFsmContext } from "../pickup-dropoff-order/WayPointsSelectionFsmContext";

export class TentativeBookingCreationFsmContext {
    constructor(
        public readonly tripCustomizationContext: SeatReservationFsmContext|WayPointSelectionFsmContext,
        public readonly travellerInfo: TravellerDTO,
        public readonly tentativeBooking?: TentativeBookingDTO
    ) { }    

    withTravellerInfo(travellerInfo: TravellerDTO) {
        return new TentativeBookingCreationFsmContext(
            this.tripCustomizationContext, travellerInfo);
    }

    withTentativeBooking(tentativeBooking: TentativeBookingDTO) {
        return new TentativeBookingCreationFsmContext(
            this.tripCustomizationContext, this.travellerInfo, tentativeBooking); 
    }
}